export default __webpack_public_path__ + "static/media/default.3f3103ed26ac42506644810c69ec5482.png";